import ModalContainer, {
  ModelContainerProps,
} from "../../ui-elements/modal-container/modal-container";

interface IProps extends ModelContainerProps {
  message: string | JSX.Element;
}

const InfoModal = (props: IProps) => {
  const { ...rest } = props;
  return (
    <ModalContainer {...rest} confirmButtonText="Okay" size="modal-md">
      <p className="font-size-14 text-color-2 m-0">{props.message}</p>
    </ModalContainer>
  );
};

export default InfoModal;
